import { get } from 'lodash';
import { withRouter } from 'next/router';
import Head from 'next/head';
import PropTypes from 'prop-types';
import React from 'react';

import useCoverImage from '../hooks/useCoverImage';
import useEntity from '../hooks/useEntity';

const SEO = ({ storyId, router }) => {
  const story = useEntity({ id: storyId, type: 'stories' });
  const member = useEntity({ id: get(story, 'member.id', ''), type: 'members' });
  const imageURL = useCoverImage({ id: storyId, version: 2 }); // width 768

  const title = `${member['first-name']} has shared '${story.title}' with you`;
  const description = `${member['first-name']} has shared the story '${
    story.title
  }' with you on LifeTales. Connect with ${member['first-name']} and stay in the loop!`;

  const twitterHandle = '@lifetalesapp';
  const contentType = 'website';
  // const siteUrl = 'https://public.lifetales.com';
  const pageUrl = `${process.env.siteURL}/story/${router.query.id}`;

  return (
    <Head>
      <title>{title}</title>
      <meta charSet="utf-8" key="meta-charset" />
      <meta itemProp="name" content={title} key="meta-itemProp-name" />
      <meta itemProp="description" content={description} key="meta-itemProp-description" />
      <meta itemProp="image" content={imageURL} key="meta-itemProp-image" />
      <meta name="description" content={description} key="meta-name-description" />
      <meta name="twitter:card" content="summary_large_image" key="meta-name-twitterCard" />
      <meta name="twitter:site" content={twitterHandle} key="meta-name-twitterSite" />
      <meta name="twitter:title" content={title} key="meta-name-twitterTitle" />
      <meta name="twitter:description" content={description} key="meta-name-twitterDescription" />
      <meta name="twitter:creator" content={twitterHandle} key="meta-name-twitterCreator" />
      <meta name="twitter:image:src" content={imageURL} key="meta-name-twitterImageSrc" />
      <meta name="og:title" content={title} key="meta-name-ogTitle" />
      <meta name="og:type" content={contentType} key="meta-name-ogType" />
      <meta name="og:url" content={pageUrl} key="meta-name-ogUrl" />
      <meta name="og:image" content={imageURL} key="meta-name-ogImage" />
      <meta name="og:description" content={description} key="meta-name-ogDescription" />
      <meta name="og:site_name" content={title} key="meta-name-ogSiteName" />
      <link rel="canonical" href={pageUrl} key="link-rel-canonical" />
    </Head>
  );
};

SEO.propTypes = {
  storyId: PropTypes.string.isRequired,
  router: PropTypes.shape({
    asPath: PropTypes.string,
  }).isRequired,
};

export default withRouter(SEO);
